import api from '@/services/utils/apiInstance.ts'
import type {
  UpdateUserRequest,
  UpdatePasswordRequest,
  TradingApiKeyResponse
} from "@/types/services/profile/profile.type.ts";

class ProfileService {
  async updateUser(userData: UpdateUserRequest): Promise<void> {
    await api.patch('/profile/update', {
      firstName: userData.firstName,
      lastName: userData.lastName,
    });
  }

  async updatePassword(passwordData: UpdatePasswordRequest): Promise<void> {
    await api.patch('/profile/update-password', {
      currentPassword: passwordData.currentPassword,
      newPassword: passwordData.newPassword,
    });
  }

  async getTradingApiKey(): Promise<TradingApiKeyResponse> {
    const response = await api.get('/trading-api-key');
    return {
      apiKey: response.data.api_key
    };
  }

  async generateTradingApiKey(): Promise<TradingApiKeyResponse> {
    const response = await api.post('/trading-api-key');
    return {
      apiKey: response.data.api_key
    };
  }

  async revokeTradingApiKey(): Promise<void> {
    await api.delete('/trading-api-key');
  }
}

export default new ProfileService();
